import { Link } from "react-router-dom";

export default function ContentSection() {
  return (
    <section className="w-full py-20 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 items-start mb-14">
          <h2 className="text-4xl md:text-5xl font-display font-extrabold text-foreground-900 leading-[1.15] flex-shrink-0">
            Hipobuy Sheet<br />Guides &amp; Resources
          </h2>
          <p className="text-base md:text-lg text-foreground-500 leading-relaxed max-w-md pt-2">
            Expert-curated shopping intelligence, product database walkthroughs, and in-depth comparison guides to help you navigate the world of organized product discovery.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
          >
            <div className="h-[260px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20workspace%20with%20laptop%20showing%20spreadsheet%20data%20and%20product%20images%20on%20screen%2C%20warm%20natural%20lighting%20from%20window%2C%20organized%20desk%20with%20notebook%20and%20coffee%2C%20cream%20and%20beige%20aesthetic%2C%20editorial%20workspace%20photography%20with%20soft%20shadows&width=800&height=500&seq=article-main-guide&orientation=landscape"
                alt="The Definitive Hipobuy Spreadsheet Guide"
                title="Hipobuy Spreadsheet Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-6">
              <span className="text-xs font-semibold text-primary-500 bg-primary-50 px-3 py-1 rounded-full">Pillar Article</span>
              <h3 className="mt-3 text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                The Definitive Hipobuy Spreadsheet Guide
              </h3>
              <p className="mt-2 text-sm text-foreground-400">
                Updated 2026 &middot; Expert Reviewed &middot; 8 Min Read
              </p>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                Everything you need to know about using hipobuy spreadsheets for smarter product discovery, from beginner basics to advanced comparison strategies.
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                Read Article
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/best-hipobuy-finds-2026"
            className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
          >
            <div className="h-[260px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20of%20trending%20fashion%20items%20sneakers%20hoodies%20and%20accessories%20arranged%20beautifully%20on%20warm%20cream%20surface%2C%20soft%20diffused%20lighting%2C%20minimal%20elegant%20composition%2C%20warm%20earthy%20color%20palette%2C%20editorial%20product%20photography&width=800&height=500&seq=article-best-finds&orientation=landscape"
                alt="Best Hipobuy Finds 2026"
                title="Hipobuy Finds 2026"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-6">
              <span className="text-xs font-semibold text-accent-500 bg-accent-50 px-3 py-1 rounded-full">Curated</span>
              <h3 className="mt-3 text-xl font-heading font-bold text-foreground-900 group-hover:text-accent-500 transition-colors">
                Best Hipobuy Finds 2026
              </h3>
              <p className="mt-2 text-sm text-foreground-400">
                Trending &middot; Weekly Updates &middot; 6 Min Read
              </p>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                Handpicked product discoveries from every category in the hipobuy spreadsheet database. Fresh finds updated weekly across shoes, hoodies, accessories, and more.
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-accent-500 group-hover:text-accent-600 transition-colors">
                Read Article
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/hipobuy-spreadsheet-comparison"
            className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
          >
            <div className="h-[260px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Split%20screen%20concept%20showing%20two%20product%20collections%20side%20by%20side%20on%20warm%20neutral%20background%2C%20minimalist%20comparison%20aesthetic%2C%20clean%20organized%20layout%2C%20soft%20natural%20lighting%2C%20cream%20and%20beige%20tones%2C%20editorial%20product%20photography%20with%20gentle%20shadows&width=800&height=500&seq=article-compare-v2&orientation=landscape"
                alt="Platform Comparison Center"
                title="Spreadsheet Comparison Center"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-6">
              <span className="text-xs font-semibold text-secondary-500 bg-secondary-50 px-3 py-1 rounded-full">Analysis</span>
              <h3 className="mt-3 text-xl font-heading font-bold text-foreground-900 group-hover:text-secondary-500 transition-colors">
                Platform Comparison 2026
              </h3>
              <p className="mt-2 text-sm text-foreground-400">
                In-Depth &middot; Side-by-Side &middot; 9 Min Read
              </p>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                Compare hipobuy sheet with Kakobuy, CSSBuy, Superbuy, and Oopbuy spreadsheets. Feature breakdowns, honest reviews, and a recommendation engine to find your best fit.
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-secondary-500 group-hover:text-secondary-600 transition-colors">
                Read Article
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/hipobuy-spreadsheet-beginners"
            className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
          >
            <div className="h-[260px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20desk%20scene%20from%20above%20with%20open%20laptop%20displaying%20clean%20organized%20spreadsheet%20beside%20steaming%20coffee%20and%20small%20potted%20plant%2C%20soft%20morning%20sunlight%20through%20nearby%20window%20casting%20gentle%20shadows%20on%20cream%20linen%20desk%20mat%2C%20handwritten%20notes%20in%20notebook%20visible%2C%20minimalist%20productive%20atmosphere%20in%20beige%20and%20warm%20ivory%20tones&width=800&height=500&seq=article-beginners-v2&orientation=landscape"
                alt="Hipobuy Spreadsheet Beginner Guide"
                title="Beginner Spreadsheet Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-6">
              <span className="text-xs font-semibold text-foreground-500 bg-foreground-50 px-3 py-1 rounded-full">Tutorial</span>
              <h3 className="mt-3 text-xl font-heading font-bold text-foreground-900 group-hover:text-foreground-700 transition-colors">
                Complete Beginner Guide
              </h3>
              <p className="mt-2 text-sm text-foreground-400">
                Step-by-Step &middot; No Experience Needed &middot; 7 Min Read
              </p>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                Start from zero with the hipobuy sheet. A friendly walkthrough covering everything from picking your first category to building a smart shopping workflow.
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-foreground-600 group-hover:text-foreground-800 transition-colors">
                Read Article
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}